// import React from "react";
// import { Box, Typography, IconButton } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// const PreviewTestimonials = ({ data, onEdit, onDelete }) => {
//   const handleCardClick = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (onEdit) {
//       onEdit("testimonials", index);
//     }
//   };

//   const handleDelete = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (window.confirm("Are you sure you want to delete this testimonial?")) {
//       if (onDelete) {
//         onDelete("testimonials", index);
//       }
//     }
//   };

//   return (
//     <Box onClick={(e) => e.stopPropagation()}>
//       <Typography
//         variant="caption"
//         color="text.secondary"
//         fontWeight={600}
//         display="block"
//         mb={1}
//       >
//         {data.clientCount} · {data.tagline}
//       </Typography>

//       <Box display="flex" gap={2} flexWrap="wrap" mt={2}>
//         {data.items
//           .filter((i) => i.quote)
//           .map((item, i) => (
//             <Box
//               key={i}
//               onClick={(e) => handleCardClick(i, e)}
//               sx={{
//                 flex: "0 0 280px",
//                 background: "rgba(255,255,255,0.05)",
//                 border: "1px solid rgba(255,255,255,0.1)",
//                 borderRadius: "10px",
//                 p: 2,
//                 cursor: "pointer",
//                 transition: "all 0.2s",
//                 position: "relative",
//                 "&:hover": {
//                   background: "rgba(255,255,255,0.08)",
//                   borderColor: "#3b82f6",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
//                 },
//               }}
//             >
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: 8,
//                   right: 8,
//                   display: "flex",
//                   gap: 0.5,
//                 }}
//               >
//                 <IconButton
//                   size="small"
//                   onClick={(e) => handleDelete(i, e)}
//                   sx={{
//                     width: 24,
//                     height: 24,
//                     background: "rgba(244,67,54,0.1)",
//                     color: "#f44336",
//                     "&:hover": {
//                       background: "rgba(244,67,54,0.2)",
//                     },
//                   }}
//                 >
//                   <DeleteOutlineIcon sx={{ fontSize: 14 }} />
//                 </IconButton>
//                 <IconButton
//                   size="small"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleCardClick(i, e);
//                   }}
//                   sx={{
//                     width: 24,
//                     height: 24,
//                     background: "rgba(59,130,246,0.1)",
//                     color: "#3b82f6",
//                     "&:hover": {
//                       background: "rgba(59,130,246,0.2)",
//                     },
//                   }}
//                 >
//                   <EditIcon sx={{ fontSize: 14 }} />
//                 </IconButton>
//               </Box>

//               <Box display="flex" flexDirection="column" gap={1.5}>
//                 {/* Quote Icon */}
//                 <Typography fontSize={32} color="#3b82f6" lineHeight={1}>
//                   "
//                 </Typography>

//                 {/* Quote */}
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     display: "-webkit-box",
//                     WebkitLineClamp: 3,
//                     WebkitBoxOrient: "vertical",
//                   }}
//                 >
//                   {item.quote}
//                 </Typography>

//                 {/* Reviewer Info */}
//                 <Box display="flex" alignItems="center" gap={1} mt={1}>
//                   {item.reviewerPhoto ? (
//                     <Box
//                       component="img"
//                       src={item.reviewerPhoto}
//                       sx={{
//                         width: 40,
//                         height: 40,
//                         borderRadius: "50%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   ) : (
//                     <Box
//                       sx={{
//                         width: 40,
//                         height: 40,
//                         borderRadius: "50%",
//                         background: "rgba(59,130,246,0.1)",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <Typography fontSize={16}>⭐</Typography>
//                     </Box>
//                   )}
//                   <Box>
//                     <Typography variant="subtitle2" fontWeight={600} noWrap>
//                       {item.reviewerName || "Anonymous"}
//                     </Typography>
//                     {item.reviewerRole && (
//                       <Typography variant="caption" color="text.secondary" noWrap>
//                         {item.reviewerRole}
//                       </Typography>
//                     )}
//                   </Box>
//                 </Box>
//               </Box>
//             </Box>
//           ))}

//         {!data.items.some((i) => i.quote) && (
//           <Typography variant="caption" color="text.secondary">
//             No testimonials added yet
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default PreviewTestimonials;


import React from "react";
import { Box, Typography } from "@mui/material";
import SummaryCard from "../shared/SummaryCard";

const PreviewTestimonials = ({ data, onEdit, onDelete }) => (
  <Box onClick={(e) => e.stopPropagation()}>
    {(data.clientCount || data.tagline) && (
      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={1}>
        {data.clientCount} · {data.tagline}
      </Typography>
    )}

    <Box display="flex" gap={2} flexWrap="wrap" mt={2}>
      {data.items.filter((i) => i.quote).length === 0 ? (
        <Typography variant="caption" color="text.secondary">No testimonials added yet</Typography>
      ) : (
        data.items.filter((i) => i.quote).map((item, i) => (
          <SummaryCard
            key={i}
            width={280}
            onClick={() => onEdit?.("testimonials", i)}
            onDelete={() => onDelete?.("testimonials", i)}
          >
            <Box display="flex" flexDirection="column" gap={1.5}>
              <Typography fontSize={32} color="#3b82f6" lineHeight={1}>"</Typography>

              <Typography
                variant="body2"
                sx={{ display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" }}
              >
                {item.quote}
              </Typography>

              <Box display="flex" alignItems="center" gap={1} mt={1}>
                {item.reviewerPhoto ? (
                  <Box component="img" src={item.reviewerPhoto} sx={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }} />
                ) : (
                  <Box sx={{ width: 40, height: 40, borderRadius: "50%", background: "rgba(59,130,246,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Typography fontSize={16}>⭐</Typography>
                  </Box>
                )}
                <Box>
                  <Typography variant="subtitle2" fontWeight={600} noWrap>{item.reviewerName || "Anonymous"}</Typography>
                  {item.reviewerRole && (
                    <Typography variant="caption" color="text.secondary" noWrap>{item.reviewerRole}</Typography>
                  )}
                </Box>
              </Box>
            </Box>
          </SummaryCard>
        ))
      )}
    </Box>
  </Box>
);

export default PreviewTestimonials;